module.exports = __webpack_public_path__ + "img/Canis_major.5a5a1105.png";